import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import IranFlag from "../../assets/images/iran.webp";
import api from "../../api";
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import '../../css/cover.css';
import '../../css/styles.css';
import DeleteIcon from '@material-ui/icons/Delete';
import LoadingSpinner from "../Loading";
import {toast, ToastContainer} from "react-toastify";
import SmoothingImage from "../../assets/images/smoothing-removebg-preview.png";
import {p2e, e2p} from "../../utils/utils";


function CarSmoothing() {
    const [car, setCar] = useState(null);
    const [items, setItems] = useState([]);
    const [smoothingFullCost, setSmoothingFullCost] = useState(0);
    const [paintingFullCost, setPaintingFullCost] = useState(0);
    const [smoothingFullDuration, setSmoothingFullDuration] = useState(0);
    const [paintingFullDuration, setPaintingFullDuration] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [newRepairItem, setNewRepairItem] = useState({
        item_name: '',
        description: '',
        full_price: 0,
        duration: 0,
    });
    
    const {carId} = useParams();
    const {requestId} = useParams();
    
    const handleCreateItem = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        newRepairItem.full_price = newRepairItem.full_price.replace(/,/g, '');
        newRepairItem.full_price = parseInt(p2e(newRepairItem.full_price));
        newRepairItem.duration = parseInt(p2e(newRepairItem.duration));
        if (!newRepairItem.full_price || !newRepairItem.duration) {
            toast.error('فیلد قیمت و زمان باید عدد باشد.')
            return
        }
        const requestData = {
            item_name: newRepairItem.item_name,
            description: newRepairItem.description,
            full_price: newRepairItem.full_price,
            duration: newRepairItem.duration,
            type: 1,
            repair_request_id: requestId
        }
        try {
            const response = await api.post('/repair-item', requestData);
            setIsLoading(false);
            toast.success('مورد صافکاری با موفقیت اضافه شد.')
            setSmoothingFullCost(smoothingFullCost + response.data.data.full_price);
            setSmoothingFullDuration(smoothingFullDuration + response.data.data.duration);
            setItems([...items, response.data.data]);
            setNewRepairItem({
                item_name: '',
                description: '',
                full_price: 0,
                duration: 0,
            })
        } catch (error) {
            setIsLoading(false);
            toast.error(error.response.data.message)
        }
    }
    
    useEffect(() => {
        setIsLoading(true);
        
        async function fetchSmoothingItems() {
            const response = await api.get(`/repair-item/smoothing/${requestId}`);
            setItems(response.data.data);
            setSmoothingFullCost(response.data.fullCost)
            setSmoothingFullDuration(response.data.totalDuration)
        }
        
        fetchSmoothingItems();
        
        async function fetchPaintingItems() {
            const response = await api.get(`/repair-item/painting/${requestId}`);
            setPaintingFullCost(response.data.fullCost)
            setPaintingFullDuration(response.data.totalDuration)
        }
        
        fetchPaintingItems();
        
        async function fetchCar() {
            const response = await api.get(`/car/${carId}`);
            setCar(response.data.data);
        }
        
        fetchCar();
        setIsLoading(false);
    }, []);
    
    const handleDeleteClick = (itemId) => {
        setIsLoading(true);
        api.delete(`/repair-item/${itemId}`)
            .then(response => {
                setIsLoading(false);
                toast.success('مورد صافکاری با موفقیت حذف شد.')
                const item = items.find(item => item.id === itemId);
                setSmoothingFullCost(smoothingFullCost - item.full_price);
                setSmoothingFullDuration(smoothingFullDuration - item.duration);
                setItems(items.filter(item => item.id !== itemId));
            })
            .catch(error => {
                toast.error(error.response.data.message)
            });
    };
    
    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        
                        {car &&
                            <div className="row d-block justify-content-center g-0">
                                <div className="mx-auto h-auto" style={{width: '20rem'}}>
                                    <img
                                        src={SmoothingImage}
                                        alt="paintingImage"
                                        className="text-center img-fluid h-auto"
                                    />
                                </div>
                                <div className="row mx-auto pelak g-0 mb-3 mt-3" style={{width: '20rem'}}>
                                    <div className="col">
                                        <div className="row my-auto">
                                            <div className="col border-start border-end-0">
                                                <p className="text-center fw-bold iranNo">ایران</p>
                                                <div>
                                                    <p className="border-0 text-center">{car?.plate.slice(7, 9)}</p>
                                                </div>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(3, 6)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(2, 3)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(0, 2)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto leftSide">
                                        <div className="flag">
                                            <img src={IranFlag} alt="iran's flag"/>
                                        </div>
                                        <div className="iranText text-center">
                                            <p>I.R.</p>
                                            <p>IRAN</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {car &&
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                    <div className="card rounded-4 border-3 border-dark mb-4">
                                        <h5 className="card-header bg-dark text-white text-center">افزودن مورد
                                            صافکاری</h5>
                                        <div className="card-body">
                                            <form action="">
                                                <div className="row mb-3">
                                                    <div className="col-6">
                                                        <label htmlFor="loc" className="form-label">محل</label>
                                                        <select
                                                            required
                                                            id="loc"
                                                            className="form-select"
                                                            name="item_name"
                                                            value={newRepairItem.item_name}
                                                            onChange={(e) => {
                                                                setNewRepairItem({
                                                                    ...newRepairItem,
                                                                    item_name: e.target.value
                                                                });
                                                            }}
                                                        >
                                                            <option>--انتخاب کنید--</option>
                                                            <option value="آینه">آینه</option>
                                                            <option value="پالانی عقب چپ">پالانی عقب چپ</option>
                                                            <option value="پالانی عقب راست">پالانی عقب راست</option>
                                                            <option value="جلو پنجره">جلو پنجره</option>
                                                            <option value="چراغ جلو چپ">چراغ جلو چپ</option>
                                                            <option value="چراغ جلو راست">چراغ جلو راست</option>
                                                            <option value="چراغ عقب چپ">چراغ عقب چپ</option>
                                                            <option value="چراغ عقب راست">چراغ عقب راست</option>
                                                            <option value="درب جلو چپ">درب جلو چپ</option>
                                                            <option value="درب جلو راست">درب جلو راست</option>
                                                            <option value="درب صندوق">درب صندوق</option>
                                                            <option value="درب عقب چپ">درب عقب چپ</option>
                                                            <option value="درب عقب راست">درب عقب راست</option>
                                                            <option value="درب موتور">درب موتور</option>
                                                            <option value="درب ها">درب ها</option>
                                                            <option value="رکاب چپ">رکاب چپ</option>
                                                            <option value="رکاب راست">رکاب راست</option>
                                                            <option value="داخل کابین">داخل کابین</option>
                                                            <option value="گلگیر جلو چپ">گلگیر جلو چپ</option>
                                                            <option value="گلگیر جلو راست">گلگیر جلو راست</option>
                                                            <option value="گلگیر عقب چپ">گلگیر عقب چپ</option>
                                                            <option value="گلگیر عقب راست">گلگیر عقب راست</option>
                                                            <option value="گارد جلو">گارد جلو</option>
                                                            <option value="گارد عقب">گارد عقب</option>
                                                            <option value="باربند">باربند</option>
                                                            <option value="سپر جلو">سپر جلو</option>
                                                            <option value="سپر عقب">سپر عقب</option>
                                                            <option value="سقف خودرو">سقف خودرو</option>
                                                            <option value="کف صندوق">کف صندوق</option>
                                                            <option value="دور گلگیر">دور گلگیر</option>
                                                            <option value="سینی پشت سپر">سینی پشت سپر</option>
                                                            <option value="سینی عقب">سینی عقب</option>
                                                            <option value="کشیدن جای زبانه قفل">کشیدن جای زبانه قفل
                                                            </option>
                                                            <option value="دیاق سپر">دیاق سپر</option>
                                                            <option value="سینی شاسی">سینی شاسی</option>
                                                            <option value="کلاف ستون">کلاف ستون</option>
                                                            <option value="ستون ها">ستون ها</option>
                                                            <option value="لوله ها">لوله ها</option>
                                                            <option value="کلاف ها">کلاف ها</option>
                                                            <option value="بغل دری">بغل دری</option>
                                                            <option value="قالپاق">قالپاق</option>
                                                            <option value="ابرویی">ابرویی</option>
                                                            <option value="آفتابگیر">آفتابگیر</option>
                                                            <option value="شاسی قفل کن درب">شاسی قفل کن درب</option>
                                                            <option value="هزینه کل">هزینه کل</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-6">
                                                        <label htmlFor="f-type" className="form-label">نوع تعمیر</label>
                                                        <select
                                                            required
                                                            id="desc"
                                                            className="form-select"
                                                            name="description"
                                                            value={newRepairItem.description}
                                                            onChange={(e) => {
                                                                setNewRepairItem({
                                                                    ...newRepairItem,
                                                                    description: e.target.value
                                                                });
                                                            }}
                                                        >
                                                            <option>--انتخاب کنید--</option>
                                                            <option value="اوراق کردن">اوراق کردن</option>
                                                            <option value="بادگیری">بادگیری</option>
                                                            <option value="باز و بست">باز و بست</option>
                                                            <option value="بی رنگی">بی رنگی</option>
                                                            <option value="تعویض">تعویض</option>
                                                            <option value="ریگلاژ">ریگلاژ</option>
                                                            <option value="صافکاری">صافکاری</option>
                                                            <option value="کشیدن">کشیدن</option>
                                                            <option value="جک کاری موجگیری">جک کاری موجگیری</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="full_price" className="form-label">قیمت
                                                        (تومان)</label>
                                                    <input
                                                        type='text'
                                                        maxLength={15}
                                                        className="form-control"
                                                        name="full_price"
                                                        id="full_price"
                                                        value={newRepairItem.full_price}
                                                        onChange={(e) => {
                                                            setNewRepairItem({
                                                                ...newRepairItem,
                                                                full_price: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="duration" className="form-label">زمان (روز)</label>
                                                    <input
                                                        type='text'
                                                        onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                                        className="form-control"
                                                        id="duration"
                                                        name="duration"
                                                        value={newRepairItem.duration}
                                                        onChange={(e) => {
                                                            setNewRepairItem({
                                                                ...newRepairItem,
                                                                duration: e.target.value
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="d-grid gap-2">
                                                    <input
                                                        type="submit"
                                                        className="btn btn-warning"
                                                        name="submit"
                                                        value="افزودن"
                                                        onClick={handleCreateItem}
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                        <h5 className="card-header bg-dark text-white text-center">جزئیات صافکاری</h5>
                                        <div className="card-body">
                                            <table className="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th className="text-center">نوع تعمیر</th>
                                                    <th className="text-center">زمان (روز)</th>
                                                    <th className="text-center">مبلغ (تومان)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td className="text-center">صافکاری</td>
                                                    <td className="text-center">{e2p(smoothingFullDuration.toString())}</td>
                                                    <td className="text-center">{e2p(smoothingFullCost?.toLocaleString()) ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">نقاشی</td>
                                                    <td className="text-center">{e2p(paintingFullDuration.toString())}</td>
                                                    <td className="text-center">{e2p(paintingFullCost?.toLocaleString()) ?? ' '}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3">
                                                        <table className="table table-warning mb-0">
                                                            {items.map((item, index) => (
                                                                <tr style={{height: '35px'}}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.item_name}</td>
                                                                    <td>{item.description}</td>
                                                                    <td>{e2p(item.duration.toString())} روز</td>
                                                                    <td>{e2p(item.full_price?.toLocaleString()) ?? ''}</td>
                                                                    <td><DeleteIcon
                                                                        onClick={() => handleDeleteClick(item.id)}
                                                                        className="p-1 cursor-pointer"
                                                                    /></td>
                                                                </tr>
                                                            ))}
                                                        </table>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div
                                        className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 d-grid gap-2">
                                        <input
                                            type="button"
                                            className="btn btn-success mb-2"
                                            name="button1"
                                            value="مرحله بعد"
                                            onClick={() => {
                                                window.location.href = `/car/${carId}/painting/${requestId}`
                                            }}
                                        />
                                    </div>
                                    <div
                                        className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 d-grid gap-2">
                                        <input
                                            type="button"
                                            className="btn btn-secondary mb-2"
                                            name="button3"
                                            value="مرحله قبل"
                                            onClick={() => {
                                                window.location.href = `/car/${carId}/reception/${requestId}`
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    
                    </div>
                </div>
            }
        </div>
    )
}

export default CarSmoothing;
